import React from 'react';
import '../styles/pages/BonelessWings.css';

const BonelessWings = () => {
  return (
    <div className="boneless-wings-page">
      <div className="hero">
        <img src="/images/boneless_wings.jpg" alt="Boneless Wings" className="hero-image" />
        <div className="hero-text">
          <h1>Boneless Wings</h1>
          <p>Savor the perfect blend of crispy coating and tender chicken, tossed in your choice of our signature sauces.</p>
          <button className="order-button">Order Now</button>
        </div>
      </div>
      
      <div className="content">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🔥</div>
            <h3>Choose Your Heat</h3>
            <p>From mild to wild, customize your wings with our range of signature sauces.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3>Premium Quality</h3>
            <p>Made with 100% premium white meat chicken, hand-breaded to perfection.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🌟</div>
            <h3>Fresh & Hot</h3>
            <p>Cooked to order and served piping hot, just the way you like them.</p>
          </div>
        </div>

        <div className="sauce-section">
          <h2>Our Signature Sauces</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Classic Buffalo</h3>
              <p>Traditional wing sauce with the perfect balance of heat and flavor.</p>
            </div>
            <div className="feature-card">
              <h3>Sweet Thai Chili</h3>
              <p>Sweet and spicy Asian-inspired sauce with a sticky glaze.</p>
            </div>
            <div className="feature-card">
              <h3>Garlic Parmesan</h3>
              <p>Creamy garlic sauce with aged Parmesan cheese.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonelessWings;
